import { mapApiOrderTemplate, mapApiOrderTemplates, mapOrderTemplate } from "./mappers";
import { useCallback, useState } from "react";

import { ApiBranch } from "../customer/interface.api";
import { ApiHooksProps } from "../interface";
import { ApiOrderTemplate } from "./interface.api";
import { OrderTemplate } from "@/types";
import { OrderTemplateApi } from "./interface";
import { request } from "../request";

const hook = ({ setError, setLoading, setSuccess, serverPath, token }: ApiHooksProps): OrderTemplateApi => {
  const [orderTemplates, setOrderTemplates] = useState<OrderTemplate[]>([]);
  
  const activateItem = useCallback(async (id: number, customerid?: string | null) => {
    const path = `${serverPath}/order-templates/activate/${id}/${customerid || '0'}`;
    request(path, { token });
    setSuccess('Package activated');
  }, [serverPath, token]);

  const clearOrderTemplates = () =>{ setOrderTemplates([]);}
  
  const cloneItem = useCallback(async (id: number) => {
    const path = `${serverPath}/order-templates/clone-template/${id}`;
    await request(path, { token });
    setSuccess('Package cloned');
  }, [serverPath, token]);
  
  const deactivateItem = useCallback(async (id: number, customerid?: string | null) => {
    const path = `${serverPath}/order-templates/deactivate/${id}/${customerid || '0'}`;
    request(path, { token });
    setSuccess('Package deactivated');
  }, [serverPath, token]);

  const deleteItem = useCallback(async (id: number) => {
    const path = `${serverPath}/order-templates/delete/${id}`;
    request(path, { token });
    setSuccess('Package deleted');
  }, [serverPath, token]);

  const details = useCallback(async (id: number) => {
    setLoading(true);
    const path = `${serverPath}/order-templates/details/${id}`;
    const res = await request<never, ApiOrderTemplate>(path, { token });
    setLoading(false);
    
    return mapApiOrderTemplate(res)
  }, [serverPath, token]);

  const getList = useCallback(async (branches: ApiBranch[]) => {
    const path = `${serverPath}/order-templates/list/`;

    setLoading(true);
    try {
      const res = await request<ApiBranch[], ApiOrderTemplate[]>(path, { body: branches, token });
      setOrderTemplates(mapApiOrderTemplates(res))
    } catch (error: unknown) {
      if (typeof error === 'string') {
        setError(error);
      }
      else if (error instanceof Error) {
        setError(error.message || '');
      }
    };
    setLoading(false);
  }, [serverPath, token]);

  const getServices = useCallback(async (id: number) => {
    const path = `${serverPath}/order-templates/list/`;
    const body = { OrderTemplateId: id };
    request(path, { body, token });
  }, [serverPath, token]);

  const set = useCallback(async (orderTemplate: OrderTemplate) => {
    const path = `${serverPath}/order-templates/set/`;
    setLoading(true);
    const body = mapOrderTemplate(orderTemplate);

    await request(path, { body, token });
    setLoading(false);
  }, [serverPath, token]);

  return {
    activateItem,
    clearOrderTemplates,
    cloneItem,
    deactivateItem,
    deleteItem,
    details,
    getList,
    getServices,
    orderTemplates,
    set
  }
}

export default hook;